import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-21',
  templateUrl: './21.component.html',
})
export class VbGeneral21Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
